// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 993) return "static/chunks/993.a14902fb5979ebd5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"286":"d03a26a14b49bab9","909":"3fd4643cf7a3c87f","980":"0f088f171fbae5df"}[chunkId] + ".js";
};